export enum DatePeriod {
    TODAY = 'Today',
    YESTERDAY = 'Yesterday',
    THIS_WEEK = 'This Week',
    PAST_7_DAYS = 'Last 7 Seven Days',
    THIS_MONTH = 'This Month',
    PAST_30_DAYS = 'Last 30 Days',
    PAST_60_DAYS = 'Last 60 Days',
    PAST_90_DAYS = 'Last 90 Days',
    PAST_180_DAYS = 'Last 180 Days',
    LAST_WEEK = 'Last Week',
    LAST_MONTH = 'Last Month',
}

export interface DateAndPeriod {
    period?: DatePeriod,
    startDate: Date | null,
    endDate: Date | null,
}

export interface DateInputProps {
    onChange: (a: Date | null) => void,
    value: Date | null,
    minDate?: Date,
    maxDate?: Date,
    label: string,
    helperText?: string,
    fieldError?: boolean,
    required?: boolean,
    disabled?: boolean,
}
